import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getAccountManagementCanvasByUserAccountIdData = (userAccountId, state, setState) => {
  if (userAccountId > 0) {
    const api = initApi(API_NAMES.SECURITY, state, setState);
    const userAccountIdForUrl = encodeURIComponent(userAccountId);
    const url = `/UserAccounts/${userAccountIdForUrl}/Canvas`;

    return api?.executeObject ? api.executeObject(url, 'GET') : null;
  }
};

const AccountManagementCanvasData = {
  getAccountManagementCanvasByUserAccountIdData
};

export default AccountManagementCanvasData;